import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useState } from 'react';
import logoImageDark from '../images/logos/logo_dark.svg';
import logoImage from '../images/logos/logo_ligth.svg';

function PrivacyPolicyPage() {
  const [lang, setLang] = useState('pt');
  const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

  const textStyle = { fontSize: '16px', lineHeight: '1.8', color: 'var(--text-color)' };

  return (
    <div className="card flex justify-content-center mt-8 mb-5">
      <Card
        header={
          <div className="text-center">
            <img
              className="p-4"
              alt="Logo"
              src={isDark ? logoImageDark : logoImage}
              height={140}
            />
            <h1>Privacy Policy / Política de Privacidade</h1>

            <div className="flex justify-content-center gap-2 mt-3">
              <Button label="Português" onClick={() => setLang('pt')} />
              <Button label="English" onClick={() => setLang('en')} />
            </div>
          </div>
        }
        className="md:w-45rem shadow-8 border-round-3xl"
        style={{ width: "800px", padding: "2em" }}
      >

        <div style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: '10px', ...textStyle }}>

          {/* ================= PORTUGUÊS (INTEGRAL) ================= */}
          {lang === 'pt' && (
            <>
              <h2>Política de Privacidade de Dinefer App</h2>

              <h3>1. Quem Somos</h3>
              <p>DINEFER PORTUGAL, com sede em A.L.E. – Rua R, Lote 45, 6000-459 Castelo Branco, é a responsável pelo tratamento dos dados pessoais recolhidos pela aplicação móvel Dinefer App.</p>
              <p>Contactos: comercial@dinefer.com</p>

              <h3>2. Âmbito</h3>
              <p>Esta Política explica que dados recolhemos, para que finalidades, durante quanto tempo os mantemos, com quem os partilhamos, quais os seus direitos ao abrigo do RGPD (Regulamento (UE) 2016/679) e legislação nacional aplicável, e como os pode exercer.</p>

              <h3>3. Dados Pessoais que Recolhemos</h3>
              <p>A app pode recolher e tratar as seguintes categorias:</p>
              <ul>
                <li>Dados de conta/identificação: nome, email, organização.</li>
                <li>Credenciais: hash de palavra-passe, tokens de sessão (nunca guardamos a palavra-passe em texto simples).</li>
                <li>Dados de utilização: ações na app.</li>
                <li>Dados de dispositivo: versão da app, identificadores de dispositivo.</li>
                <li>Notificações: tokens de notificação push.</li>
                <li>Registos e diagnóstico: logs de erro e desempenho para suporte.</li>
              </ul>

              <h3>4. Finalidades e Fundamentos de Licitude</h3>
              <p>Tratamos os dados para:</p>
              <ul>
                <li>Fornecer e operar a app (execução de contrato).</li>
                <li>Autenticação e gestão de contas (execução de contrato).</li>
                <li>Atendimento, suporte técnico e segurança (interesse legítimo/obrigação legal).</li>
                <li>Melhoria contínua, métricas e analytics (interesse legítimo; quando necessário e proporcional).</li>
                <li>Comunicações transacionais (execução de contrato).</li>
              </ul>
              <p>Quando o tratamento se baseia no consentimento, pode retirá-lo a qualquer momento sem afetar a licitude do tratamento anterior.</p>

              <h3>5. Prazos de Conservação</h3>
              <p>Conservamos os dados apenas pelo período necessário às finalidades:</p>
              <ul>
                <li>Conta e perfil: enquanto a conta estiver ativa e até [1 ano] após o encerramento.</li>
                <li>Registos de acesso e logs: até [12 meses].</li>
              </ul>

              <h3>6. Segurança</h3>
              <p>Implementamos medidas técnicas e organizativas apropriadas (controlo de acessos, encriptação em trânsito e repouso quando aplicável, backups e monitorização, registo de acessos, hardening de servidores) para proteger os dados contra acesso não autorizado, perda ou alteração.</p>

              <h3>7. Direitos dos Titulares (RGPD)</h3>
              <p>Tem direito a aceder, retificar, apagar, limitar ou opor-se ao tratamento, e à portabilidade dos seus dados. Quando o tratamento assenta em consentimento, pode retirá-lo a qualquer momento.</p>
              <p>Tem também direito a apresentar reclamação junto da autoridade de controlo competente (em Portugal, CNPD).</p>

              <h3>8. Como Exercer os seus Direitos</h3>
              <p>Para exercer os seus direitos, contacte-nos por comercial@dinefer.com. Podemos solicitar informação adicional para confirmar a sua identidade antes de responder.</p>

              <h3>9. Crianças</h3>
              <p>A app não é destinada a menores de 13/16. Não recolhemos intencionalmente dados de crianças sem consentimento verificável dos pais/responsáveis.</p>

              <h3>10. Permissões do Dispositivo (Android/iOS)</h3>
              <p>A app poderá solicitar, sempre que necessário e justificado, as seguintes permissões:</p>
              <ul>
                <li>Câmara: para leitura de códigos de barras/QR.</li>
                <li>NFC: para leitura de tags NFC.</li>
                <li>Notificações: para receber alertas e mensagens transacionais.</li>
              </ul>

              <h3>11. Decisões Automatizadas e Profiling</h3>
              <p>Não realizamos decisões exclusivamente automatizadas com efeitos legais ou semelhantes.</p>

              <h3>12. Alterações a esta Política</h3>
              <p>Podemos atualizar esta Política. Publicaremos a versão atualizada na app/website e indicaremos a data da última atualização. Sempre que as alterações forem materiais, informaremos por canais adequados.</p>

              <h3>13. Contactos</h3>
              <ul>
                <li>Responsável pelo tratamento: DINEFER PORTUGAL, A.L.E. – Rua R, Lote 45, 6000-459 Castelo Branco, PORTUGAL</li>
                <li>Email geral/suporte: comercial@dinefer.com</li>
                <li>Data de entrada em vigor: 25 de Outubro de 2025</li>
              </ul>
            </>
          )}

          {/* ================= ENGLISH (FULL TRANSLATION) ================= */}
          {lang === 'en' && (
            <>
              <h2>Privacy Policy of Dinefer App</h2>

              <h3>1. Who We Are</h3>
              <p>DINEFER PORTUGAL, headquartered at A.L.E. – Rua R, Lote 45, 6000-459 Castelo Branco, is responsible for processing personal data collected by the Dinefer App mobile application.</p>
              <p>Contacts: comercial@dinefer.com</p>

              <h3>2. Scope</h3>
              <p>This Policy explains what data we collect, for what purposes, how long we retain it, with whom we share it, your rights under the GDPR (Regulation (EU) 2016/679) and applicable national legislation, and how you can exercise them.</p>

              <h3>3. Personal Data We Collect</h3>
              <p>The app may collect and process the following categories:</p>
              <ul>
                <li>Account/identification data: name, email, organization.</li>
                <li>Credentials: password hash, session tokens (we never store passwords in plain text).</li>
                <li>Usage data: actions in the app.</li>
                <li>Device data: app version, device identifiers.</li>
                <li>Notifications: push notification tokens.</li>
                <li>Logs and diagnostics: error and performance logs.</li>
              </ul>

              <h3>4. Purposes and Legal Bases</h3>
              <p>We process data to:</p>
              <ul>
                <li>Provide and operate the app (performance of a contract).</li>
                <li>Authentication and account management (performance of a contract).</li>
                <li>Support and security (legitimate interest/legal obligation).</li>
                <li>Continuous improvement and analytics (legitimate interest).</li>
                <li>Transactional communications (performance of a contract).</li>
              </ul>
              <p>Where processing is based on consent, you may withdraw it at any time.</p>

              <h3>5. Retention</h3>
              <ul>
                <li>Account: active + 1 year</li>
                <li>Logs: up to 12 months</li>
              </ul>

              <h3>6. Security</h3>
              <p>We implement appropriate technical and organizational measures to protect data.</p>

              <h3>7. Rights</h3>
              <p>You have the right to access, rectify, erase, restrict or object to processing.</p>

              <h3>8. Contact</h3>
              <p>comercial@dinefer.com</p>

              <h3>9. Children</h3>
              <p>The app is not intended for children.</p>

              <h3>10. Permissions</h3>
              <ul>
                <li>Camera</li>
                <li>NFC</li>
                <li>Notifications</li>
              </ul>

              <h3>11. Automated Decisions</h3>
              <p>No automated decision-making is performed.</p>

              <h3>12. Updates</h3>
              <p>We may update this policy.</p>

              <h3>13. Effective Date</h3>
              <p>October 25, 2025</p>
            </>
          )}

        </div>
      </Card>
    </div>
  );
}

export default PrivacyPolicyPage;